import { OverlayToaster, Position } from "@blueprintjs/core";
import { segmentTrackFavoriteBusToggled } from "analytics/analyticTrackEvents";
import { MAP_CURVE, MAP_SPEED, MAP_ZOOM } from "components/map/MapComponent";
import RemoveFavoriteChip from "components/sidebar/BusItem/RemoveFavoriteChip";
import { useFavoriteBuses } from "contexts/FavoriteBusesContext/FavoriteBusesContext";
import useMapViewConfiguration from "contexts/MapViewConfigurationContext/hooks/useMapViewConfiguration";
import React from "react";
import { ScopedBus } from "types/busType";
import BusItem from "./BusItem";
import "./FavoritesPanelRow.scss";

// Undo toast for unfavoriting from the panel
const FavoritePanelToaster = OverlayToaster.create({ position: Position.TOP });

type FavoritesPanelRowProps = {
    readonly scopedBus: ScopedBus;
};

const FavoritesPanelRow: React.FC<FavoritesPanelRowProps> = ({ scopedBus }) => {
    const { removeFavorite, addFavorite } = useFavoriteBuses();
    const { boundingBoxConfiguration } = useMapViewConfiguration();
    const { niraBusId, busDisplayName, longitude, latitude } = scopedBus.bus;

    // BusItem's own click selects the bus; fly the map to it as well, so
    // favorites outside the current view are reachable from the panel.
    const flyToBus = (): void => {
        const mapRef = boundingBoxConfiguration.currentMapRef;
        if (mapRef !== null) {
            mapRef.flyTo({
                center: [longitude, latitude],
                zoom: MAP_ZOOM,
                curve: MAP_CURVE,
                speed: MAP_SPEED
            });
        }
    };

    const unfavorite = (): void => {
        removeFavorite(niraBusId);
        segmentTrackFavoriteBusToggled(niraBusId, false, "favorites_panel");
        FavoritePanelToaster.show({
            message: `Removed ${busDisplayName} from favorites`,
            action: {
                text: "Undo",
                onClick: () => {
                    addFavorite(niraBusId);
                    segmentTrackFavoriteBusToggled(
                        niraBusId,
                        true,
                        "favorites_panel"
                    );
                }
            }
        });
    };

    return (
        <div className="FavoritesPanelRow-wrapper" onClick={flyToBus}>
            <BusItem
                isLoading={false}
                scopedBus={scopedBus}
                selectionSource="favorites_panel"
            />
            <span className="FavoritesPanelRow-remove">
                <RemoveFavoriteChip
                    busDisplayName={busDisplayName}
                    onRemove={unfavorite}
                />
            </span>
        </div>
    );
};

export default FavoritesPanelRow;
